const ROUTES = [
  'value_propositions/\\d+/\\w+/bmc_boards/\\d*||value_propositions/\\d+/\\w+/tasks/\\d*',
  'dashboards/product/value_propositions/\\d+/\\w+/bmc_boards/\\d*||dashboards/product/value_propositions/\\d+/\\w+/tasks/\\d*',
  'bmc_boards/\\d*',

  'memberships/\\w+/bmc_boards/\\d*',
  'memberships/bmc_boards/\\d*',

  'dashboards/business/\\w+/bmc_boards/\\d*',
  'dashboards/business/bmc_boards/\\d*',

  'customers/\\w+/bmc_boards/\\d*',
  'customers/bmc_boards/\\d*'
];

const ROUTE_PATH = `/:locale?/(${ROUTES.join('|')})`;

const KEY_RESOURCES_PURPOSES = {
  PHYSICAL: 'physical',
  FINANCIAL: 'Financial',
  HUMAN: 'human',
  INTELLECTUAL: 'Intellectual'
};

const KEY_ACTIVITY_TYPES = {
  PRODUCTION: 'production',
  PROBLEM_SOLVING: 'problem_solving',
  PLATFORM_NETWORK: 'platform_network',
  EARN_REVENUES: 'earn_revenues'
};

const KEY_PARTNER_TYPES = {
  OPTIMIZATION: 'optimization_economy_scale',
  ACQUISITION_RESOURCES: 'acquisition_particular_resources',
  REDUCTION: 'reduction_risk_uncertainty',
  ACQUISITION_ACTIVITIES: 'acquisition_particular_activities'
};

const BLOCK_NAME_BY_KEY = {
  0: { name: 'key_partners', color: '#B5D275', icon: '\uf0c1' },
  1: { name: 'key_activities', color: '#B5D275', icon: '\uf058' },
  2: { name: 'key_resources', color: '#B5D275', icon: '\uf275' },
  3: { name: 'key_propositions', color: '#CB4E44', icon: '\uf06b' },
  4: { name: 'customer_relationships', color: '#7182BE', icon: '\uf21e' },
  5: { name: 'channels', color: '#7182BE', icon: '\uf0d1' },
  6: { name: 'customer_segments', color: '#7182BE', icon: '\uf0c0' },
  7: { name: 'cost_structure', color: '#64C3D3', icon: '\uf080' },
  8: { name: 'revenue_streams', color: '#64C3D3', icon: '\uf155' }
};

const STEPS_BY_SECTION = {
  infrastructure: [2, 1, 0], // Indexes matter!
  innovation: [3],
  customer_relationships: [6, 5, 4], // same here
  monetization: [8, 7] // and here
};

const NEXT_STEP_UNBUNDLED_BMC = {
  // infrastructure
  0: 1,
  1: 2,
  2: 0,
  // customer relations
  6: 5,
  5: 4,
  4: 6,
  // 'monetization'
  7: 8,
  8: 7
};

const PREV_STEP_UNBUNDLED_BMC = {
  // infrastructure
  0: 2,
  1: 0,
  2: 1,
  // customer relations
  6: 4,
  5: 6,
  4: 5,
  // 'monetization'
  7: 8,
  8: 7
};

export {
  ROUTE_PATH,
  KEY_RESOURCES_PURPOSES,
  KEY_ACTIVITY_TYPES,
  KEY_PARTNER_TYPES,
  BLOCK_NAME_BY_KEY,
  STEPS_BY_SECTION,
  NEXT_STEP_UNBUNDLED_BMC,
  PREV_STEP_UNBUNDLED_BMC
};
